import { useNavigate } from "react-router-dom";

//MUI
import { AppBar, Box, Button, styled, Toolbar, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";

//Components
import logo from "../../../../images/volt_logo.jpg";
import { HEADER_COLOR } from "../../../../theme/theme";

const StyledToolbar = styled(Toolbar)({
  display: "flex",
  justifyContent: "space-between",
  height: "100px",
});

const NAVBAR_LINKS = [
  { label: "COURS", path: "/cours" },
  { label: "INSTRUCTEURS", path: "/instructeurs" },
  { label: "GALERIE", path: "/galerie" },
  { label: "CONTACT", path: "/contact" },
];

const NAV_TEXT_COLOR = "#ffffff";

export function NavBarLarge() {
  const navigate = useNavigate();

  const handleNavClick = (link: string) => {
    navigate(link);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <AppBar position="sticky" sx={{ backgroundColor: HEADER_COLOR }}>
      <StyledToolbar disableGutters sx={{ pr: 2 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
          width="100%"
        >
          <Button
            variant="text"
            disableElevation
            sx={{
              p: 0,
              minWidth: 0,
              color: NAV_TEXT_COLOR,
              "&:hover": {
                color: alpha(NAV_TEXT_COLOR, 0.6),
              },
            }}
            onClick={() => {
              handleNavClick("/");
            }}
          >
            <Box component="img" src={logo} height="100px" alt="Volt BJJ" />
          </Button>
          <Box display="flex" alignItems="center" gap={2}>
            {NAVBAR_LINKS.map((item) => (
              <Button
                key={item.path}
                variant="text"
                disableElevation
                sx={{
                  color: NAV_TEXT_COLOR,
                  "&:hover": {
                    color: alpha(NAV_TEXT_COLOR, 0.6),
                  },
                }}
                onClick={() => handleNavClick(item.path)}
              >
                <Typography variant="h6">{item.label}</Typography>
              </Button>
            ))}
          </Box>
        </Box>
      </StyledToolbar>
    </AppBar>
  );
}
